export const getVinculacionMonto = row => {
  const monto = Number(row?.montoTotal ?? row?.monto ?? 0)
  if (Number(row?.folioCredito) === 6 && monto === 0) {
    const montoPrestamo = Number(row?.extra?.monto ?? row?.extras?.monto)
    if (Number.isFinite(montoPrestamo)) return montoPrestamo
  }
  return monto
}
